var map = {
	"./ACOS.svg": "6ff4",
	"./Add.svg": "d760",
	"./Admin Home.svg": "d346",
	"./Ads Reporting.svg": "3f95",
	"./Arrow_Down.svg": "27c1",
	"./Arrow_Left.svg": "56a5",
	"./Arrow_Right.svg": "96f0",
	"./Arrow_Up.svg": "c940",
	"./Automated systems.svg": "8ab5",
	"./Automated.svg": "2275",
	"./Availability Tracking.svg": "4963",
	"./Best Sellers Ranking.svg": "0247",
	"./Buybox Monitor.svg": "74e1",
	"./CPC.svg": "aade",
	"./CPM.svg": "cf2f",
	"./Category.svg": "d568",
	"./Centralized data.svg": "4e84",
	"./CheckCode.svg": "5c08",
	"./Clicks.svg": "0999",
	"./Compliance Automation.svg": "22ba",
	"./Compliance New.svg": "0a7a",
	"./Connect Your Account.svg": "6023",
	"./Conversion Rate.svg": "05cc",
	"./Cost.svg": "6392",
	"./Customized.svg": "127f",
	"./Dashboard.svg": "7e93",
	"./Date.svg": "2233",
	"./Download.svg": "6e370",
	"./DownloadArrow.svg": "a788",
	"./DownloadIcon.svg": "b2f0",
	"./Error free.svg": "4d9e",
	"./Filter.svg": "d54a",
	"./Form.svg": "9dd9",
	"./GaLoginImg.svg": "3f71b",
	"./GaLoginImgNew.svg": "d56c",
	"./Important Bulletin.svg": "eccd",
	"./Impressions.svg": "cc26",
	"./Inhouse ecosystem.svg": "6813",
	"./Inventory Management.svg": "e47d",
	"./Inventory.svg": "0e12",
	"./Key Metrics.svg": "7459",
	"./LQS Analyser.svg": "d55e",
	"./Listing Analyser.svg": "1f4b",
	"./Location.svg": "a26f",
	"./Logout.svg": "b44be",
	"./LqsImgLogin.svg": "2e1a",
	"./Market Explorer.svg": "38d7",
	"./Market.svg": "59ed",
	"./MarketPlaces.svg": "34da",
	"./Minus.svg": "89a5",
	"./Orders.svg": "9338",
	"./Overall spends.svg": "280a",
	"./Password.svg": "b37e",
	"./Phrase Analyser.svg": "0b7c",
	"./Plus.svg": "ca84",
	"./Price Tracking.svg": "571f",
	"./Price.svg": "ebce",
	"./Product_Tracking.svg": "d693",
	"./Profile Dropdown.svg": "64e3",
	"./ROI.svg": "19b0",
	"./Remaining stock.svg": "6ba5",
	"./Remove.svg": "2e90",
	"./Reports.svg": "916f",
	"./Revenue.svg": "ca07",
	"./Reviews and Ratings.svg": "a575",
	"./SOV Report.svg": "489b",
	"./SQL Sync.svg": "178f",
	"./Search.svg": "a17d",
	"./Sentiments.svg": "ad03",
	"./Setting3.svg": "5e93",
	"./Share of Search.svg": "c528",
	"./Share of Voice.svg": "5902",
	"./Sidebar Toggle Left.svg": "5926",
	"./Sidebar Toggle Right.svg": "0b91",
	"./Sort.svg": "b8cf",
	"./Spider Management.svg": "272a",
	"./Spider Monitor.svg": "fdc3",
	"./Submit.svg": "19a3",
	"./Summary.svg": "addf",
	"./Tooltip.svg": "82d2",
	"./Total Inward Count.svg": "71ff",
	"./Total Outward Count.svg": "24a4",
	"./Total SKU Count.svg": "6e72",
	"./Total Warehouse.svg": "6d48",
	"./User.svg": "21ec",
	"./UserProfile.svg": "5527",
	"./Usermanagement.svg": "f1a8",
	"./Visual analysis.svg": "ffc3",
	"./Warehouse Summary.svg": "04c6",
	"./Weavrwise.svg": "b67f",
	"./Your Sentiments.svg": "2fa9",
	"./addMorePlusArrow.svg": "c9d1",
	"./addMoreProduct.svg": "e496",
	"./addNewBrand.svg": "4643",
	"./amazonWeavr.svg": "40cb",
	"./bars-solid.svg": "1aaf",
	"./bgCouponImg.svg": "25bc",
	"./bgImgLogin.svg": "59f2",
	"./blackTrash.svg": "5b16",
	"./calenderIcon.svg": "0e4d",
	"./cancelled_invoice_amount.svg": "4931",
	"./check.svg": "4817",
	"./checkIcon.svg": "a341",
	"./close.svg": "7ee9",
	"./companyIconWeavr.svg": "5ca4",
	"./connectAccountIcon.svg": "306e",
	"./couponGiftIcon.svg": "30b3",
	"./cross.svg": "ff6e",
	"./crossIcon.svg": "5a13",
	"./dataInsightsLoginImg.svg": "8867",
	"./deleteBtn.svg": "7b88",
	"./deleteBtnSvg.svg": "39ff",
	"./demoGoorejImg.svg": "c5c6",
	"./demoProgressDataImg.svg": "f0c8",
	"./downArrowC.svg": "6f88",
	"./downArrowLQS.svg": "ca19",
	"./downPriceArrow.svg": "d276",
	"./editBtn.svg": "54b1",
	"./emailWeavr.svg": "8500",
	"./flagArrowsCountry.svg": "ca92",
	"./flipkartWeavr.svg": "1c4f",
	"./googleAdsWeavr.svg": "e1e3",
	"./heroIconGift.svg": "468b",
	"./infoIcon.svg": "db34",
	"./linkdinWeavr.svg": "6c62",
	"./lockPermission.svg": "01d9",
	"./logoutIcon.svg": "7db2",
	"./metaLoginImg.svg": "f373",
	"./metaLoginImgNew.svg": "10f7",
	"./net_sales.svg": "76f5",
	"./newSellerBuybox.svg": "e44f",
	"./noProductImage.svg": "1368",
	"./noProductImageForComparison.svg": "5129",
	"./old_icons/Admin Home_old.svg": "9890",
	"./old_icons/Availability Tracking_old.svg": "6b36",
	"./old_icons/Best Sellers Ranking_old.svg": "afc9",
	"./old_icons/Buybox Monitor_old.svg": "f3da",
	"./old_icons/Compliance Automation_old.svg": "f6c4",
	"./old_icons/Compliance Automation_solid.svg": "25ce",
	"./old_icons/Compliance New_old.svg": "6f64",
	"./old_icons/LQS Analyser_old.svg": "fb68",
	"./old_icons/Market Explorer_old.svg": "962c",
	"./old_icons/Phrase Analyser_old.svg": "8812",
	"./old_icons/Price Tracking_old.svg": "ec77",
	"./old_icons/Reviews and Ratings_old.svg": "b778",
	"./old_icons/SOV Report_old.svg": "56ad",
	"./old_icons/SQL Sync_old.svg": "8b2f",
	"./old_icons/Share of Search_old.svg": "bd0e",
	"./old_icons/Share of Voice_old.svg": "3cf5",
	"./old_icons/Spider Management_old.svg": "464e",
	"./old_icons/Spider Monitor_old.svg": "4424",
	"./old_icons/Summary_old.svg": "e3e7",
	"./passwordWeavr.svg": "e07f",
	"./phoneIcon.svg": "ce05",
	"./pieGraphImgLogin.svg": "5a7d",
	"./pincodeLoginLeftImg.svg": "68f6",
	"./priceup.svg": "4f4b",
	"./profile-svg.svg": "3d5e",
	"./profileIcon.svg": "23ba",
	"./progressDataImgUpdated.svg": "bff5",
	"./rating_star.svg": "4f06",
	"./redTrash.svg": "8d47e",
	"./removedynamicCard.svg": "8813",
	"./rto_invoice_amount.svg": "824e",
	"./rtv_invoice_amount.svg": "7888",
	"./settings.svg": "00c37",
	"./shopifyLoginImg.svg": "913f",
	"./snapchatLoginImg.svg": "b010",
	"./success_loader.svg": "73269",
	"./swapArrows.svg": "5780",
	"./totalInvoice.svg": "2eff",
	"./total_sales.svg": "da4a",
	"./trash.svg": "5c73",
	"./twitterLoginImg.svg": "5b57",
	"./twitterLoginImgNew.svg": "d270",
	"./upArrowC.svg": "8eaf",
	"./upArrowLQS.svg": "76c4",
	"./upPriceArrow.svg": "4f1a",
	"./userIconWeavr.svg": "f256",
	"./userlogs.svg": "2323",
	"./weavr-login-img.svg": "b0e0",
	"./wifiIcon.svg": "41ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02bd";